export const BRAND_NAME = "QuickClaw";
export const PROJECT_NAME = "quickclaw";
export const SITE_DOMAIN = "quickclaw.pro";
export const SITE_URL = "https://quickclaw.pro";
export const SUPPORT_EMAIL = "support@quickclaw.pro";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
